import React from 'react';
import { BooleanButtonLabel, BooleanInputHidden, BooleanInput, BooleanInputContainer, BooleanInputGreenCircle, LabelSpacer, BooleanInputErrorText } from './style';

export const InputBoolean = ({ 
    isChecked = false, 
    label = "Label", 
    name = "",
    type = "radio",
    errorText = "",
    isSmall = false,
    isLabelBold = false,
    onChange = () => {},
}) => {
    return (
        <div style={{ width: '100%' }}>
            <BooleanButtonLabel>
                <BooleanInputContainer isSmall={isSmall}>
                    <BooleanInput isCircle={type === 'radio'} isSmall={isSmall}/>
                    <BooleanInputGreenCircle isCircle={type === 'radio'} isVisible={isChecked} isSmall={isSmall} />
                </BooleanInputContainer>
                <LabelSpacer isLabelBold={isLabelBold}>{label}</LabelSpacer>
                <BooleanInputHidden type={type} checked={isChecked} onChange={onChange} name={name} /> 
            </BooleanButtonLabel>
            {errorText && <BooleanInputErrorText>{errorText}</BooleanInputErrorText>}
        </div>
    );
}